// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__dX-L7","lds-default":"Loading_lds-default__Y84a1"};